import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { default as Scheme$dc40 } from '/app/src/config/auth/EmailScheme.js'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/login",
    "home": false,
    "callback": false
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": false,
  "defaultStrategy": "agents"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // agents
  $auth.registerStrategy('agents', new Scheme$dc40($auth, {
  "user": {
    "property": false,
    "autoFetch": false
  },
  "endpoints": {
    "login": {
      "method": "post",
      "url": "/api/auth/email"
    },
    "logout": {
      "method": "post",
      "url": "/api/agents/logout"
    },
    "user": {
      "method": "get",
      "url": "/api/agents/me"
    }
  },
  "name": "agents"
}))

  // represes
  $auth.registerStrategy('represes', new Scheme$dc40($auth, {
  "user": {
    "property": false,
    "autoFetch": false
  },
  "endpoints": {
    "login": {
      "method": "post",
      "url": "/api/auth/email"
    },
    "logout": {
      "method": "post",
      "url": "/api/represes/logout"
    },
    "user": {
      "method": "get",
      "url": "/api/represes/me"
    }
  },
  "name": "represes"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
